import { createRouter, createWebHistory } from 'vue-router'


const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: () => import('../views/LandingView.vue')
    },
    {
      path: '/aed-register',
      component: () => import('../views/AedRegisterView.vue')
    },
    {
      path: '/pribehy',
      component: () => import('../views/StoriesView.vue')
    },
    {
      path: '/pribehy/:slug',
      component: () => import('../views/StoryDetailView.vue')
    }
  ],
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

export default router
